import Button from '@material-ui/core/Button';
import { SnackbarKey, SnackbarProvider } from 'notistack';
import React, { FC, PropsWithChildren } from 'react';

const GcpSnackBarProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const notiStackRef = React.createRef<SnackbarProvider>();
  const onClickDismiss = (key: SnackbarKey): void => {
    notiStackRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notiStackRef}
      action={(key): JSX.Element => (
        <Button
          aria-label="close"
          onClick={() => {
            onClickDismiss(key);
          }}
        >
          X
        </Button>
      )}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      hideIconVariant={false}
      maxSnack={3}
    >
      {children}
    </SnackbarProvider>
  );
};

export default GcpSnackBarProvider;
